/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { redirect, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import OpportunityForm from "../../components/OpportunityForm";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";

function DocUploadingPage() {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
    document.title = "Processing Document - Nclude Portal";
  }, []);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="docAccessibility" />
        <div className="doc-container" role="main" tabIndex={-1}>
          <section>
          <div className="component-container center uploading">
            <img src="/doc-access.svg" alt="Illustration of document processing" className="instruction-img" />
            <h1 className="display-title center" ref={mainRef} tabIndex={-1}>
              {"Processing Your Uploaded File"}
            </h1>
            <p>
              We will send you a notification with the link to download
              converted file when the results are ready
            </p>
            <button
              className="center upload-button"
              onClick={() => navigate("/docaccess")}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  navigate("/docaccess");
                }
              }}
              aria-label="Navigate back to the document accessibility page"
            >
              Ok, Got it
            </button>
          </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default DocUploadingPage;
